import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../../images/logo-fff.png';

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const Footer2 = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();

    const isActive = (path) => {
        const currentPath = '/' + location.pathname.split('/').slice(2).join('/');
        return currentPath === path || currentPath.startsWith(path + '/');
    };

    useEffect(() => {
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-9JYXJRY7SR';
        document.head.appendChild(gtagScript);

        const inlineScript = document.createElement('script');
        inlineScript.textContent = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-9JYXJRY7SR');
        `;
        document.head.appendChild(inlineScript);

        return () => {
            if (gtagScript.parentNode) gtagScript.parentNode.removeChild(gtagScript);
            if (inlineScript.parentNode) inlineScript.parentNode.removeChild(inlineScript);
        };
    }, []);

    return (
        <footer className="xb-modern-footer">
            <section className="audit-cta-section">
                <div className="container">
                    <div className="audit-cta-box">
                        <div className="audit-cta-glow" />
                        <div className="ai-text">
                            <span className="audit-badge"><i className="fas fa-chart-line" /> {t('common.free')}</span>
                            <h2 className="audit-title">{t('home.cta.title')}</h2>
                            <p className="audit-subtitle">{t('home.cta.subtitle')}</p>
                        </div>
                        <Link to={`/${i18n.language}/audit`} className="audit-btn" title={t('home.cta.button')}>
                            {t('home.cta.button')}
                            <i className="fas fa-arrow-right ms-2" />
                        </Link>
                    </div>
                </div>
            </section>
            <div className="xb-footer-glow-line" />

            <div className="container">
                <div className="xb-footer-grid">

                    {/* Col 1 – Brand */}
                    <div className="xb-footer-brand">
                        <Link onClick={ClickHandler} to={`/${i18n.language}`} className="xb-footer-logo" title="OrbitroniX">
                            <img src={logo} alt="OrbitroniX Logo" title="OrbitroniX" />
                        </Link>
                        <p className="xb-footer-tagline">
                            {t('footer.tagline')}
                        </p>
                        <div className="xb-footer-socials">
                            <a href="https://www.facebook.com/orbitronixge" target="_blank" rel="noreferrer" className="xb-social-pill" aria-label="Facebook" title="Facebook">
                                <i className="fab fa-facebook-f" />
                            </a>
                            <a href="https://www.linkedin.com/company/orbitronixge/" target="_blank" rel="noreferrer" className="xb-social-pill" aria-label="LinkedIn" title="LinkedIn">
                                <i className="fab fa-linkedin-in" />
                            </a>
                        </div>
                    </div>

                    {/* Col 2 – Company */}
                    <div className="xb-footer-col">
                        <h6 className="xb-footer-col-title">{t('footer.company')}</h6>
                        <ul className="xb-footer-links">
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/about`} title={t('navigation.about')}>{t('navigation.about')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/services`} title={t('navigation.services')}>{t('navigation.services')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/portfolio`} title={t('navigation.portfolio')}>{t('navigation.portfolio')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/blog`} title={t('navigation.blog')}>{t('navigation.blog')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/contact`} title={t('navigation.contact')}>{t('navigation.contact')}</Link></li>
                        </ul>
                    </div>

                    {/* Col 3 – Services */}
                    <div className="xb-footer-col">
                        <h6 className="xb-footer-col-title">{t('footer.services')}</h6>
                        <ul className="xb-footer-links">
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/services/web-development`} className={isActive('/services/web-development') ? 'active' : ''} title={t('services.webDevelopment')}>{t('services.webDevelopment')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/services/mobile-apps`} className={isActive('/services/mobile-apps') ? 'active' : ''} title={t('services.mobileApps')}>{t('services.mobileApps')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/services/infrastructure`} className={isActive('/services/infrastructure') ? 'active' : ''} title={t('services.infrastructure')}>{t('services.infrastructure')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/services/partnership`} className={isActive('/services/partnership') ? 'active' : ''} title={t('services.partnership')}>{t('services.partnership')}</Link></li>
                        </ul>
                    </div>

                    {/* Col 4 – Industries */}
                    <div className="xb-footer-col">
                        <h6 className="xb-footer-col-title">{t('footer.industries')}</h6>
                        <ul className="xb-footer-links">
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/industries/personal`} className={isActive('/industries/personal') ? 'active' : ''} title={t('industries.personal')}>{t('industries.personal')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/industries/business`} className={isActive('/industries/business') ? 'active' : ''} title={t('industries.business')}>{t('industries.business')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/industries/gov`} className={isActive('/industries/gov') ? 'active' : ''} title={t('industries.gov')}>{t('industries.gov')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/industries/learning`} className={isActive('/industries/learning') ? 'active' : ''} title={t('industries.learning')}>{t('industries.learning')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/industries/ai`} className={isActive('/industries/ai') ? 'active' : ''} title={t('industries.ai')}>{t('industries.ai')}</Link></li>
                        </ul>
                    </div>

                    {/* Col 5 – Partners */}
                    <div className="xb-footer-col">
                        <h6 className="xb-footer-col-title">{t('partners.title')}</h6>
                        <ul className="xb-footer-links">
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/partners/become`} className={isActive('/partners/become') ? 'active' : ''} title={t('partners.menu.become')}>{t('partners.menu.become')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/partner/dashboard`} className={isActive('/partner/dashboard') ? 'active' : ''} title={t('partners.menu.dashboard')}>{t('partners.menu.dashboard')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/partner/materials`} className={isActive('/partner/materials') ? 'active' : ''} title={t('partners.menu.materials')}>{t('partners.menu.materials')}</Link></li>
                            <li><Link onClick={ClickHandler} to={`/${i18n.language}/partner/offers`} className={isActive('/partner/offers') ? 'active' : ''} title={t('partners.menu.offers')}>{t('partners.menu.offers')}</Link></li>
                        </ul>
                    </div>

                </div>

                {/* ── Contact strip ── */}
                <div className="xb-footer-contact-strip">
                    <a href="mailto:hello@orbitronix.ge" className="xb-contact-chip" title="Email OrbitroniX">
                        <span className="xb-chip-icon"><i className="fas fa-envelope" /></span>
                        <div>
                            <span className="xb-chip-label">{t('footer.emailUs')}</span>
                            <span className="xb-chip-value">hello@orbitronix.ge</span>
                        </div>
                    </a>
                    <div className="xb-contact-chip">
                        <span className="xb-chip-icon xb-chip-sky"><i className="fas fa-map-marker-alt" /></span>
                        <div>
                            <span className="xb-chip-label">{t('footer.ourOffice')}</span>
                            <span className="xb-chip-value">{t('footer.address')}</span>
                        </div>
                    </div>
                    <a href="tel:+995555275685" className="xb-contact-chip" title="Call OrbitroniX +(995) 555 275 685">
                        <span className="xb-chip-icon xb-chip-blue"><i className="fas fa-phone" /></span>
                        <div>
                            <span className="xb-chip-label">{t('footer.callUs')}</span>
                            <span className="xb-chip-value">+(995) 555 275 685</span>
                        </div>
                    </a>
                    <a href="tel:+995557253275" className="xb-contact-chip" title="Call OrbitroniX +995 557 25 32 75">
                        <span className="xb-chip-icon xb-chip-blue"><i className="fas fa-phone" /></span>
                        <div>
                            <span className="xb-chip-label">{t('footer.callUs')}</span>
                            <span className="xb-chip-value">+995 557 25 32 75</span>
                        </div>
                    </a>
                </div>

                {/* ── Divider ── */}
                <div className="xb-footer-divider" />

                {/* ── Bottom bar ── */}
                <div className="xb-footer-bottom">
                    <p className="xb-footer-copy">
                        © {new Date().getFullYear()}{' '}
                        <Link onClick={ClickHandler} to={`/${i18n.language}`} title="OrbitroniX Home">OrbitroniX</Link>. {t('footer.allRightsReserved')}
                    </p>
                    <ul className="xb-footer-legal">
                        <li><Link onClick={ClickHandler} to={`/${i18n.language}/privacy-policy`} title={t('footer.privacy')}>{t('footer.privacy')}</Link></li>
                        <li><Link onClick={ClickHandler} to={`/${i18n.language}/terms-conditions`} title={t('footer.terms')}>{t('footer.terms')}</Link></li>
                        <li><Link onClick={ClickHandler} to={`/${i18n.language}/support`} title={t('footer.support')}>{t('footer.support')}</Link></li>
                    </ul>
                </div>

            </div>

            <style>{`
                :global(.xb-modern-footer) {
                    overflow: visible !important;
                }
                .audit-cta-section {
                    padding: 0 0 120px 0;
                    position: relative;
                    margin-top: -225px;
                }
                .audit-cta-box {
                    position: relative;
                    overflow: hidden;
                    background: linear-gradient(135deg, rgba(108, 92, 231, 0.12) 0%, rgba(20, 20, 37, 0.9) 100%);
                    border: 1px solid rgba(108, 92, 231, 0.25);
                    border-radius: 28px;
                    padding: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 40px;
                    flex-wrap: wrap;
                    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.45);
                }
                .audit-cta-glow {
                    position: absolute;
                    top: -60px;
                    right: -60px;
                    width: 260px;
                    height: 260px;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(108, 92, 231, 0.35) 0%, transparent 70%);
                    pointer-events: none;
                }
                .ai-text {
                    flex: 1;
                    min-width: 260px;
                }
                .audit-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(108, 92, 231, 0.2);
                    color: #a29bfe;
                    border: 1px solid rgba(108, 92, 231, 0.4);
                    padding: 6px 16px;
                    border-radius: 40px;
                    font-size: 10px;
                    font-weight: 700;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    margin-bottom: 18px;
                }
                .audit-title {
                    font-size: clamp(1.2rem, 2.4vw, 1.8rem);
                    font-weight: 800;
                    color: #fff;
                    line-height: 1.2;
                    margin: 0 0 10px;
                }
                .audit-subtitle {
                    color: rgba(255, 255, 255, 0.6);
                    font-size: 14px;
                    line-height: 1.7;
                    margin: 0;
                    max-width: 560px;
                }
                .audit-btn {
                    position: relative;
                    z-index: 2;
                    display: inline-flex;
                    align-items: center;
                    background: #6c5ce7;
                    color: #fff;
                    font-weight: 700;
                    padding: 12px 28px;
                    border-radius: 50px;
                    font-size: 14px;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    box-shadow: 0 12px 30px rgba(108, 92, 231, 0.35);
                }
                .audit-btn:hover {
                    background: #5a4ad1;
                    transform: translateY(-3px);
                    box-shadow: 0 18px 40px rgba(108, 92, 231, 0.45);
                }
                @media (max-width: 767px) {
                    .audit-cta-box {
                        padding: 40px 24px;
                        justify-content: center;
                        text-align: center;
                    }
                }
            `}</style>
        </footer>
    );
};

export default Footer2;